// extracted by mini-css-extract-plugin
module.exports = {"promoBox":"index-module--promoBox--1hIee","sectionWrapper":"index-module--sectionWrapper--3Mq8f","seeallBtn":"index-module--seeall-btn--3ER-1"};